(function () {
  const showButton = document.querySelector('.store-availability-button'),
    form = document.querySelector('.product__information .product__form'),
    drawer = document.querySelector('.store-availability-drawer'),
    closeButton = document.querySelector('.pickup-availability-close-button'),
    overlay = document.querySelector('.store-availability-overlay'),
    storeListContainer = document.querySelector('.store-availability-list');
  showButton === null || showButton === void 0 ? void 0 : showButton.setAttribute('disabled', 'disabled');
  showButton === null || showButton === void 0 ? void 0 : showButton.addEventListener('click', () => {
    buildStockInfo();
    drawer.setAttribute('open', '');
    document.documentElement.classList.add('enable-overlay');
  });
  function closeDrawer() {
    drawer.removeAttribute('open', '');
    document.documentElement.classList.remove('enable-overlay');
    clearStockInfo();
  }
  closeButton === null || closeButton === void 0 ? void 0 : closeButton.addEventListener('click', closeDrawer.bind(this));
  overlay === null || overlay === void 0 ? void 0 : overlay.addEventListener('click', closeDrawer.bind(this));
  async function getStoresList(unhideShowButton) {
    const variantInput = form === null || form === void 0 ? void 0 : form.querySelector('input[name="id"]');
    const variantSelector = form.querySelector('select[name="id"]');
    let variantSku = '';
    if (variantInput) {
      variantSku = variantInput.dataset.sku;
    } else if (variantSelector) {
      var _Array$from;
      const selectedOption = (_Array$from = Array.from(variantSelector.querySelectorAll('option'))) === null || _Array$from === void 0 ? void 0 : _Array$from.find(option => option.value = variantSelector.value);
      variantSku = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.dataset.sku;
    }
    if (!variantSku) return [];
    let url;

    if (Orchestra && Orchestra.find_in_store) {
      url = Orchestra.find_in_store;
    } else {
      return false;
    }

    const stores = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Referer: `${window.location.origin}`
      },
      body: JSON.stringify({
        sku: variantSku
      })
    }).then(res => res.json());
    if (stores !== null && stores !== void 0 && stores.length && unhideShowButton) {
      showButton.classList.remove('hidden');
    }
    return stores;
  }
  async function buildStockInfo() {
    const stores = await getStoresList();
    if (stores !== null && stores !== void 0 && stores.length) {
      const outOfStockEverywhere = stores.every(store => Number(store.qty) <= 0);
      stores.forEach(store => {
        let stockStatus;
        const qty = Number(store.qty);
        if (qty >= 5) {
          stockStatus = 'In Stock';
        } else if (qty < 5 && qty > 0) {
          stockStatus = 'Low Stock';
        } else if (qty <= 0) {
          stockStatus = outOfStockEverywhere ? 'Out of Stock' : '2-3 working days';
        }
        let storeAddress = store.address,
          storeStreet,
          storeCity,
          storeRegion,
          storePostcode,
          storeAddressContainer = '';
        if (storeAddress != null) {
          storeStreet = storeAddress.street, storeCity = storeAddress.city, storeRegion = storeAddress.region, storePostcode = storeAddress.postcode;
          storeAddressContainer = "<div class='store-availability-item__address'>" + storeStreet + '<br>' + storeCity + '<br>' + storeRegion + '<br>' + storePostcode + '</div>';
        }
        const stockStatusData = stockStatus.replace(/\s/g, '-').toLowerCase();
        const storeItem = document.createElement('li');
        storeItem.classList.add('store-availability-item', 'flex', 'flex-col');
        storeItem.innerHTML = "<div class='store-availability-item__info flex'><a href='/pages/stores' class='store-availability-item__title text-c_warm_black hover:text-primary'>" + store.title + '</a>' + "<div class='store-availability-item__status' data-stock-status='" + stockStatusData + "'>" + stockStatus + '</div></div>' + storeAddressContainer;
        if (store.title !== 'Warehouse') {
          storeListContainer.appendChild(storeItem);
        }
      });
    }
    storeListContainer.removeAttribute('data-loading');
  }
  function clearStockInfo() {
    storeListContainer.innerHTML = '';
    storeListContainer.setAttribute('data-loading', true);
  }
  function updateshowButton(selector) {
    var _form$querySelector;
    const variant_id = (selector === null || selector === void 0 ? void 0 : selector.value) || (form === null || form === void 0 ? void 0 : (_form$querySelector = form.querySelector('[name="id"]')) === null || _form$querySelector === void 0 ? void 0 : _form$querySelector.value);
    if (variant_id) {
      showButton === null || showButton === void 0 ? void 0 : showButton.removeAttribute('disabled');
    } else {
      showButton === null || showButton === void 0 ? void 0 : showButton.setAttribute('disabled', 'disabled');
    }
  }
  updateshowButton();
  if (showButton) {
    getStoresList(true);
  }
  const variantSelector = form === null || form === void 0 ? void 0 : form.querySelector('select[name="id"]');
  if (variantSelector) {
    variantSelector.addEventListener('change', updateshowButton.bind(this, variantSelector));
  }
})();
